<template>
    <div class="wrap type-main">
        <!-- header -->
        <div class="header">
            <div class="logo" style="margin-left: 15px;">
                <a href="#none"></a>
                <label for="toggle"><span>메뉴</span></label>
            </div>
            <div class="user-info">
                <span class="user-msg" style="color:#fff;">[{{ this.$store.state.loginInfo.loginDeptNm }}] <span class="point-blue" style="color:#fff;">{{ this.$store.state.loginInfo.userName }}</span> <span>({{ this.$store.state.loginInfo.loginId }})</span></span>
                <a href="/backOffice" class="ico ico-home" title=""></a>
                <router-link class="ico ico-top02" to="/backOffice/quickSetting"></router-link>
                <button class="ico ico-sms01" title="" @click="showSendSms" style="margin-left: 20px"></button>
                <a href="#" class="ico ico-logout" title="" @click="logout" style="margin-left: 17px"></a>
            </div>
        </div>
        <!-- //header -->
        <!-- menu -->
        <input type="checkbox" id="toggle" v-model="checked"/>
        <div class="menu-wrap" id="nav">
            <ul class="menu">
                <li v-for="(menuhead,i) in menuheads" :key="i">
                    <a>{{menuhead.menuNm}}</a>
                    <ul>
                        <li v-for="(mainmenu,i) in mainmenus" :key="i">
                            <a v-if="menuhead.menuNo === mainmenu.upperMenuNo">
                                <router-link :to="mainmenu.programFileNm" class="ico ico-top02" target="_blank" v-if="mainmenu.upperMenuNo =='8000000'">
                                  {{mainmenu.menuNm}}</router-link>
                                <router-link :to="mainmenu.programFileNm" class="ico ico-top02" v-else>
                                  {{mainmenu.menuNm}}</router-link>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </div>
        <!-- //menu -->

        <!-- contents -->
        <div class="contents2">
            <div class="inner">
                <div class="clearfix">
                    <!-- left 영역 -->
                    <div class="left">
                        <!-- 2.퀵메뉴 -->
                        <!--큌메뉴 설정 6개 이하일 경우-->
                        <ul v-if="myquicks === null" class="quick-menu-v" >
                            <li class="card">
                                <router-link class="rl" to="/backOffice/quickSetting"><img class="ico_main06_07 icon" :src="'/img/ico_main06_07.png'">
                                    <span>시스템관리</span>
                                </router-link>
                            </li>
                            <li v-for="index in six"  class="card" style="width: 211px; height: 212px;">
                            </li>
                        </ul>
                        <ul v-else-if="myquicks.length !== 6" class="quick-menu-v" >
                            <li v-for="(quick,i) in myquicks" class="card">
                                <router-link class="rl" :to="quick.programFileNm"><img :class="quickIcon[i] + ' icon'" :src="'/img/'+quickIcon[i]+'.png'">
                                    <span>{{quick.menuNm}}</span>
                                </router-link>
                            </li>
                            <li class="card">
                                <router-link class="rl" to="/backOffice/quickSetting"><img class="ico_main06_07 icon" :src="'/img/ico_main06_07.png'">
                                    <span>시스템관리</span>
                                </router-link>
                            </li>
                            <li v-for="index in six" class="card" style="width: 211px; height: 212px;">
                            </li>
                        </ul>
                        <!--큌메뉴 설정 6개일 경우-->
                        <ul v-else class="quick-menu-v" >
                            <li v-for="(quick,i) in myquicks" class="card">
                                <router-link class="rl" :to="quick.programFileNm"><img :class="quickIcon[i] + ' icon'" :src="'/img/'+quickIcon[i]+'.png'">
                                    <span>{{quick.menuNm}}</span>
                                </router-link>
                            </li>
                        </ul>
                        <!-- //2. 퀵메뉴 -->
                        <!-- 5. 방문목적 -->
                        <div class="white-box card status">
                            <div class="top-area">
                                <h1 class="box-title">올해 방문목적 통계</h1>
                            </div>
                            <div class="data-box" style="padding-top: 15px">
                                <!-- 그래프 영역 -->
                                <div class="graph-box">
                                    <div id="chartbox1" style="width:375px;height:200px;"></div>
                                </div>
                                <!-- //그래프 영역 -->
                                <div>
                                    <ul v-if="purposeConds !==''" class="status-list">
                                        <li v-for="(purpose,i) in purposeConds" :key="i">
                                            <span class="dot"></span>{{purpose.purposeNm}}
                                        </li>
                                    </ul>
                                    <ul v-if = "purposeConds.length===0" class="status-list">
                                        <li>
                                            <span class="dot"></span>없음
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <!-- //5.방문목적 -->

                    </div>
                    <!-- //left 영역 -->

                    <!-- right 영역 -->
                    <div class="right">
                        <!-- 3.오늘 방문예정 내역-->
                        <div class="white-box card main-visit">
                            <div class="top-area">
                                <h1 class="box-title">오늘 방문예정</h1>
                                <!-- <router-link class="btn-more" to="/cardSlipUseLst?useDtlsStatCd=10"></router-link> -->

                                <router-link class="btn-more" to="/backOffice/visitMngList" v-if="this.authority === '10'"></router-link>
                                <router-link class="btn-more" to="/backOffice/visitList" v-else></router-link>
                            </div>
                            <div class="data-box">
                                <!--이미지 영역-->
                                <div class="card-box" style="float: left;">
                                    <div class="calendar-month">
                                        <span class="cal-month">{{this.calendarMonth}}</span>
                                    </div>
                                    <div class="calendar-date">
                                        <span class="cal-date">{{this.calendarDay}}</span>
                                    </div>
                                </div>
                                <!--이미지 영역-->
                                <vue-simple-scrollbar class="vue-scroll">
                                    <!--오늘방문예정 리스트-->
                                    <ul class="line-list using-list" v-if="this.authority === '10'">
                                        <li v-if="expectedList.length===0">
                                            <span class="visitor-comp" style="width:200px;"> 오늘 방문 일정이 없습니다.</span>
                                        </li>
                                        <li v-for="(visit,i) in expectedList" v-else :key="i">
                                            <router-link class="rl" :to="'/backOffice/visitControlMng/'+visit.visitNo">
                                                <span class="visitor-comp">{{visit.visitorComp}}</span><span class="visitor-name">{{visit.visitorInfo}}</span><span class="time">{{visit.staTime}}~{{visit.endTime}}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                    <ul class="line-list using-list" v-else>
                                        <li v-if="expectedList.length===0">
                                            <span class="visitor-comp" style="width:200px;"> 오늘 방문 일정이 없습니다.</span>
                                        </li>
                                        <li v-for="(visit,i) in expectedList" v-else :key="i">
                                            <router-link class="rl" :to="'/backOffice/visitMng/'+visit.visitNo">
                                                <span class="visitor-comp">{{visit.visitorComp}}</span><span class="visitor-name">{{visit.visitorInfo}}</span><span class="time">{{visit.staTime}}~{{visit.endTime}}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                    <!--오늘방문예정 리스트-->
                                </vue-simple-scrollbar>
                            </div>
                        </div>
                        <!-- 3.오늘 방문예정 내역-->

                        <!-- 4. 7일이내 방문예정 내역-->
                        <div class="white-box card main-visit" style="margin-top:16px;">
                            <div class="top-area">
                                <h1 class="box-title">7일 이내 방문예정</h1>
                                <router-link class="btn-more" to="/backOffice/visitMngList" v-if="this.authority === '10'"></router-link>
                                <router-link class="btn-more" to="/backOffice/visitList" v-else></router-link>
                            </div>
                            <div class="data-box">
                                <vue-simple-scrollbar>
                                    <!--7일이내 방문예정 리스트-->
                                    <ul class="line-list week-list" v-if="this.authority === '10'">
                                        <li v-if="expectedWeekList.length===0">
                                            <span class="visitor-name" style="width:190px;">{{this.searchVDtmFr}} ~ {{this.searchVDtmTo}}</span><span class="visitor-comp" style="width:200px;">방문 일정이 없습니다.</span>
                                        </li>
                                        <li v-for="(visit,i) in expectedWeekList" v-else :key="i">
                                            <router-link class="rl" :to="'/backOffice/visitControlMng/'+visit.visitNo">
                                                <span class="visitor-comp">{{visit.visitorComp}}</span><span class="visitor-name">{{visit.visitorInfo}}</span><span class="date">{{visit.staYmd}} ~ {{visit.endYmd}}</span><span class="visit-emp-name">{{visit.visitEmpNm}} {{visit.visitEmpTitleNm}}</span>
                                            </router-link><!-- </a> -->
                                        </li>
                                    </ul>
                                    <ul class="line-list week-list" v-else>
                                        <li v-if="expectedWeekList.length===0">
                                            <span class="visitor-name" style="width:190px;">{{this.searchVDtmFr}} ~ {{this.searchVDtmTo}}</span><span class="visitor-comp" style="width:200px;">방문 일정이 없습니다.</span>
                                        </li>
                                        <li v-for="(visit,i) in expectedWeekList" v-else :key="i">
                                            <router-link class="rl" :to="'/backOffice/visitMng/'+visit.visitNo">
                                                <span class="visitor-comp">{{visit.visitorComp}}</span><span class="visitor-name">{{visit.visitorInfo}}</span><span class="date">{{visit.staYmd}} ~ {{visit.endYmd}}</span><span class="visit-emp-name">{{visit.visitEmpNm}} {{visit.visitEmpTitleNm}}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                    <!--7일이내 방문예정 리스트-->
                                </vue-simple-scrollbar>
                            </div>
                        </div>
                        <!-- 4. 7일이내 방문예정 내역-->

                        <!-- 5. 방문목적 -->
                        <div class="white-box card status_right">
                            <div class="top-area">
                                <h1 class="box-title">올해 방문목적 통계</h1>
                            </div>
                            <div class="data-box" style="margin-top: 0px; padding-top: 10px">
                                <!-- 그래프 영역 -->
                                <div class="graph-box">
                                    <div id="chartbox2" style="width:275px;height:150px;"></div>
                                </div>
                                <!-- //그래프 영역 -->
                                <div>
                                    <ul v-if="purposeConds !==''" class="status-list">
                                        <li v-for="(purpose,i) in purposeConds" :key="i">
                                            <span class="dot"></span>{{purpose.purposeNm}}
                                        </li>
                                    </ul>
                                    <ul v-if = "purposeConds.length===0" class="status-list">
                                        <li>
                                            <span class="dot"></span>없음
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <!-- //5.방문목적 -->
                    </div>
                    <!-- //right 영역 -->
                </div>
                <!-- //clearfix -->
                <!-- 6.메인처리 예정건수-->
                <ul class="blue-box">
                    <li class="blue blue01">
                        <router-link class="btn-more" to="/backOffice/visitMngList" v-if="this.authority === '10'">
                            <i class="fas fa-user-clock fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">방문신청 미처리</span><span class="txt-eng">Visit unprocessed</span><span class="count"><span> {{ this.uncounts.reqVisit && this.uncounts.reqVisit.length > 0 ? this.uncounts.reqVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                        <router-link class="btn-more" to="/backOffice/visitList?visitStatCd=15&dtmChecked&vdtmChecked" v-else>
                            <i class="fas fa-user-clock fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">방문신청 미처리</span><span class="txt-eng">Visit unprocessed</span><span class="count"><span> {{ this.uncounts.reqVisit && this.uncounts.reqVisit.length > 0 ? this.uncounts.reqVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                    </li>
                    <li class="blue blue02">
                        <router-link class="btn-more" to="/backOffice/visitMngList?visitStatCd=50" v-if="this.authority === '10'">
                            <i class="fas fa-shoe-prints fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">방문진행건</span><span class="txt-eng">Visit approval</span><span class="count"><span>{{ this.uncounts.ingVisit && this.uncounts.ingVisit.length > 0 ? this.uncounts.ingVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                        <router-link class="btn-more" to="/backOffice/visitList?visitStatCd=50" v-else>
                            <i class="fas fa-shoe-prints fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">방문진행건</span><span class="txt-eng">Visit approval</span><span class="count"><span>{{ this.uncounts.ingVisit && this.uncounts.ingVisit.length > 0 ? this.uncounts.ingVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                    </li>
                    <li class="blue blue03">
                        <router-link class="btn-more" to="/backOffice/visitMngList?visitStatCd=80" v-if="this.authority === '10'">
                            <i class="fas fa-user-times fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">방문취소건</span><span class="txt-eng">Visit canceled</span><span class="count"><span>{{ this.uncounts.canceledVisit && this.uncounts.canceledVisit.length > 0 ? this.uncounts.canceledVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                        <router-link class="btn-more" to="/backOffice/visitList?visitStatCd=80" v-else>
                            <i class="fas fa-user-times fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">방문취소건</span><span class="txt-eng">Visit canceled</span><span class="count"><span>{{ this.uncounts.canceledVisit && this.uncounts.canceledVisit.length > 0 ? this.uncounts.canceledVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                    </li>
                    <li class="blue blue04">
                        <router-link class="btn-more" to="/backOffice/visitMngList?visitStatCd=70" v-if="this.authority === '10'">
                            <i class="fas fa-question fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">미방문건</span><span class="txt-eng">No show</span><span class="count"><span>{{ this.uncounts.noShowVisit && this.uncounts.noShowVisit.length > 0 ? this.uncounts.noShowVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                        <router-link class="btn-more" to="/backOffice/visitList?visitStatCd=70" v-else>
                            <i class="fas fa-question fa-2x"></i>
                            <span class="txt-kor" style="margin-top:13px;">미방문건</span><span class="txt-eng">No show</span><span class="count"><span>{{ this.uncounts.noShowVisit && this.uncounts.noShowVisit.length > 0 ? this.uncounts.noShowVisit[0].cnt : 0 }}</span>건</span>
                        </router-link>
                    </li>
                    <li class="blue blue05">
                        <router-link to="/backOffice/apprPendLst">
                            <span class="txt-kor">결재</span><span class="txt-eng">Approve proposal</span><span class="count"><span>{{ this.uncounts.todoAppr && this.uncounts.todoAppr.length > 0 ? this.uncounts.todoAppr[0].cnt : '' }}</span>건</span>
                        </router-link>
                    </li>
                    <li class="blue blue06">
                        <router-link to="/backOffice/apprCompLst?docStatCd=REJ">
                            <span class="txt-kor">반려</span><span class="txt-eng">Return a document</span><span class="count"><span>{{ this.uncounts.rjctAppr && this.uncounts.rjctAppr.length > 0 ? this.uncounts.rjctAppr[0].cnt : '' }}</span>건</span>
                        </router-link>
                    </li>
                </ul>
                <!-- 6.메인처리 예정건수-->

            </div>
            <!-- //inner -->
        </div>
        <!-- //contents -->
        <!-- footer -->
        <div class="footer2">
            <span class="copyright">COPYRIGHT © ILJIN ALL RIGHTS RESERVED.</span>
        </div>
        <!-- //footer -->
    </div>
    <!-- //wrap -->

</template>

<script>
    import DhxGrid from '@/components/DhxGrid.vue';
    import SendSms from '@/components/SendSms.vue';
    import router from '@/router';
    import _ from "lodash";
    import VueSimpleScrollbar from 'vue-simple-scrollbar'

    export default {
        name: 'MyMain',
        components: {
            DhxGrid,
            VueSimpleScrollbar,
            SendSms
        },
        data() {
            return {
                //메인화면 전체데이터
                mymains: [],
                //1.메인메뉴
                mainmenus:[],
                menuheads:[],
                menulink:[],
                //2.메인바로가기(퀵메뉴)
                mysets:[],
                myquicks:[],
                six:[],
                quickIcon:[],
                //3.메인법인카드내역
                unCardLists:[],
                uCard:[],
                //4.메인경비처리내역
                rcSlipLists:[],
                rcSlipData:[],
                //5. 방문목적
                purposeConds:[],
                //6.메인처리예정건수
                uncounts: [],
                checked: false,
                expectedList: [],
                expectedWeekList: [],
                calendarMonth: this.$moment().locale('en').format('MMM'),
                calendarDay: this.$moment().date(),
                searchDtm: this.$moment().format('YYYY-MM-DD'),
                searchDtmTom: this.$moment().add(1, 'day').format('YYYY-MM-DD'),
                searchVDtmFr: this.$moment().add(1, 'day').format('YYYY-MM-DD'),
                searchVDtmTo: this.$moment().add(7, 'day').format('YYYY-MM-DD'),
                authority: '',
                windowWidth: 0,
                graphChk1 : false,
                graphChk2 : false,
            }
        },
        /* 숫자에 콤마(,)넣기*/
        filters:{
            currency:function (value) {
                var num = new Number(value);
                return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g,"$1,")
            }
        },
        methods: {
            //로그아웃
            logout() {
                this.$swal({
                    type: 'info',
                    html: `그룹웨어 로그아웃이 선행되야 로그아웃이 됩니다.<br>아닌경우 다시 자동 로그인 처리됩니다.<br>로그아웃을 진행하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$http
                            .get('/logout')
                            .then(() => {
                                this.$store.commit('logout');
                                this.$cookie.delete('loginInfo');
                                this.$router.push({path: `/backOffice`});
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                    }
                })
            },
            showSendSms() {
                this.$modal.open({
                    component: SendSms,
                    props: {
                        loginId: this.$store.state.loginInfo.loginId,
                        loginNm: this.$store.state.loginInfo.userName
                    },
                    parent: this,
                    width: 1000
                })
            },
            //메인화면 데이터 불러오기
            getMyMain() {
                this.$http.get(`/api/dashboard/${this.$store.state.loginInfo.compCd}/${this.$store.state.loginInfo.loginId}`)
                    .then(response => {
                        //모든 데이터
                        this.mymains = response.data;
                        //1. 메인메뉴
                        this.mainmenus = response.data.menuList;
                        //6.메인처리예정건수
                        this.uncounts = response.data.counts;

                        //1. 메인메뉴
                        let menuupper=[];
                        for(let i=0; i<this.mainmenus.length; i++){
                            if(this.mainmenus[i].upperMenuNo==0){
                                menuupper.push(this.mainmenus[i]);
                            }
                        }
                        this.menuheads =menuupper;

                        //2.메인바로가기(퀵메뉴)
                        this.myquicks = response.data.userMenuList;
                        if(this.myquicks==null){
                            this.six = 5;
                        }
                        else{
                            for(let ic=0; ic<this.myquicks.length; ic++){
                                switch (this.myquicks[ic].menuIconCd) {
                                    case '10':
                                        this.quickIcon.push( "ico_main01");
                                        break;
                                    case '20':
                                        this.quickIcon.push( "ico_main02");
                                        break;
                                    case '30':
                                        this.quickIcon.push( "ico_main03");
                                        break;
                                    case '40':
                                        this.quickIcon.push( "ico_main04");
                                        break;
                                    case '50':
                                        this.quickIcon.push( "ico_main05");
                                        break;
                                    case '60':
                                        this.quickIcon.push( "ico_main06");
                                        break;
                                    case '70':
                                        this.quickIcon.push( "ico_main06_01");
                                        break;
                                    case '80':
                                        this.quickIcon.push( "ico_main06_02");
                                        break;
                                    case '90':
                                        this.quickIcon.push( "ico_main06_03");
                                        break;
                                    case '100':
                                        this.quickIcon.push( "ico_main06_04");
                                        break;
                                    case '110':
                                        this.quickIcon.push( "ico_main06_05");
                                        break;
                                    case '120':
                                        this.quickIcon.push( "ico_main06_06");
                                        break;
                                }
                            }
                            if(this.myquicks.length!=6){
                                this.six = 5-this.myquicks.length;
                            }
                        }
                    });
            },
            goPage(params) {
                let targetName = (params.eaSlipNo === null || params.slipStatCd === '10') ? 'cardSlipReg' : 'billSlipMng';;
                this.$router.push({ name: targetName, params: params });
            },
            getMyVisitor() {
                this.$http.post(`/api/visit/expectedList`, {
                    searchDtm: this.searchDtm,
                }).then(response => {
                    if (response.data) {
                        this.expectedList = response.data;
                    }
                }).finally(() => {
                });
            },
            getMyWeekVisitor() {
                this.$http.post(`/api/visit/expectedWeekList`, {
                    searchVDtmFr: this.searchVDtmFr,
                    searchVDtmTo: this.searchVDtmTo,
                }).then(response => {
                    if (response.data) {
                        this.expectedWeekList = response.data;
                    }
                }).finally(() => {
                });
            },
            //5.방문목적 유형
            getPurposeCond1() {
                this.$http.get(`/api/dashboard/${this.$store.state.loginInfo.compCd}/${this.$store.state.loginInfo.loginId}`)
                    .then(response => {
                        this.purposeConds = response.data.purposeCond;
                        let pieData=[];
                        if(this.purposeConds.length>0){
                            pieData = this.purposeConds;
                            for(let i=0; i<pieData.length; i++){
                                if(i===0) pieData[i].color="#2a84c9";
                                else if(i===1) pieData[i].color="#f05f52";
                                else if(i===2) pieData[i].color="#f5920c";
                                else if(i===3) pieData[i].color="#14c7fe";
                                else if(i===4) pieData[i].color="#69d697";
                                else pieData[i].color="#f3c563";
                            }
                        }

                        if(pieData.length===0) pieData={ "cnt" : 10000, "color" : "#2a84c9", "purposeNm" : "사용전"}

                        let myPieChart1 = new dhtmlXChart({
                            view:"donut",
                            container:"chartbox1",
                            value:"#cnt#",
                            color:"#color#",
                            radius:70,
                            innerRadius:32,
                            label:"<span style='font-size: 12px'><b>#percent# %</b></span>",
                            //pieInnerText:"<b><span style='color: white'>#cnt#</span></b>",
                            tooltip:"<b>#purposeNm# : #cnt#건</b>",
                            shadow:false,
                        });
                        myPieChart1.parse(pieData,"json");
                    });
                this.graphChk1 = true
            },
            getPurposeCond2() {
                this.$http.get(`/api/dashboard/${this.$store.state.loginInfo.compCd}/${this.$store.state.loginInfo.loginId}`)
                    .then(response => {
                        this.purposeConds = response.data.purposeCond;
                        let pieData=[];
                        if(this.purposeConds.length>0){
                            pieData = this.purposeConds;
                            for(let i=0; i<pieData.length; i++){
                                if(i===0) pieData[i].color="#2a84c9";
                                else if(i===1) pieData[i].color="#f05f52";
                                else if(i===2) pieData[i].color="#f5920c";
                                else if(i===3) pieData[i].color="#14c7fe";
                                else if(i===4) pieData[i].color="#69d697";
                                else pieData[i].color="#f3c563";
                            }
                        }

                        if(pieData.length===0) pieData={ "cnt" : 10000, "color" : "#2a84c9", "purposeNm" : "사용전"}

                        let myPieChart = new dhtmlXChart({
                            view:"donut",
                            container:"chartbox2",
                            value:"#cnt#",
                            color:"#color#",
                            radius:52,
                            innerRadius:20,
                            label:"<span style='font-size: 11px'>#percent# %</span>",
                            //pieInnerText:"<b><span style='color: white'>#cnt#</span></b>",
                            tooltip:"<b>#purposeNm# : #cnt#건</b>",
                            shadow:false,
                        });
                        myPieChart.parse(pieData,"json");
                    });
                this.graphChk2 = true
            },
            blueBoxEffect(){
                $(".blue-box li.blue01").hover(function() {
                        $(this).stop().animate({"border-color": "#0065b3"}, 250);
                    },
                    function() {
                        $(this).stop().animate({"border-color": "#d4e8fa"}, 250);
                    });

                $(".blue-box li.blue02").hover(function() {
                        $(this).stop().animate({"border-color": "#0065b3"}, 250);
                    },
                    function() {
                        $(this).stop().animate({"border-color": "#c6e3fb"}, 250);
                    });

                $(".blue-box li.blue03").hover(function() {
                        $(this).stop().animate({"border-color": "#0065b3"}, 250);
                    },
                    function() {
                        $(this).stop().animate({"border-color": "#a9d3f6"}, 250);
                    });

                $(".blue-box li.blue04").hover(function() {
                        $(this).stop().animate({"border-color": "#0065b3"}, 250);
                    },
                    function() {
                        $(this).stop().animate({"border-color": "#8fc4f0"}, 250);
                    });

                $(".blue-box li.blue05").hover(function() {
                        $(this).stop().animate({"border-color": "#0065b3"}, 250);
                    },
                    function() {
                        $(this).stop().animate({"border-color": "#6aaee9"}, 250);
                    });

                $(".blue-box li.blue06").hover(function() {
                        $(this).stop().animate({"border-color": "#0065b3"}, 250);
                    },
                    function() {
                        $(this).stop().animate({"border-color": "#65a9e5"}, 250);
                    });
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
        mounted() {
            this.authority = this.$store.state.loginInfo.authorities.map(x => x.roleSelectCd)[0]
            this.getMyMain()
            this.getMyVisitor()
            this.getMyWeekVisitor()
            this.blueBoxEffect()

            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            })
            if(window.innerWidth > 1400)
                this.getPurposeCond1();
            else
                this.getPurposeCond2();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        watch: {
            'checked'(value) {
                if(value === true)
                    $("#nav").slideDown()
                else
                    $("#nav").slideUp()
            },
            windowWidth(newWidth, oldWidth) {
                if (oldWidth == 0) {
                    if (newWidth > '1400' && this.graphChk1 === false)
                        this.getPurposeCond1()
                    if (newWidth <= '1400' && this.graphChk2 === false)
                        this.getPurposeCond2()
                } else {
                    if (oldWidth <= 1400 && newWidth > '1400' && this.graphChk1 === false)
                        this.getPurposeCond1()
                    if (oldWidth > 1400 && newWidth <= '1400' && this.graphChk2 === false)
                        this.getPurposeCond2()
                }
            }
        }
    };

</script>

<style scoped lang="scss">
    @import "public/css/main";
    @import '~vue-simple-scrollbar/dist/vue-simple-scrollbar.css';

    .wrap.lnb.minimized~.contents2 {
        left: 50px;
    }

    /* contents */

    #nav{margin:0; padding:0; list-style:none;display:block;}
    #nav li {display:block;}
    #nav, #toggle {display:none;}

    .contents2 {
        max-width: 100%;
        min-width: 1033px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
        transition: .3s;
        padding: 0px 25px 33px 25px;
        /*overflow-y: auto;*/
    }


    .contents2>.inner-box {
        padding-bottom: 80px;
        min-height: 80vh;
    }

    .contents2 .content-name {
        margin-top: 33px;
    }

    .contents2 .content-name:after {
        clear: both;
        content: '';
        display: block;
    }

    .contents2 .content-name h2 {
        font-size: 24px;
        color: #061c3a;
        font-family: 'NotoM';
        float: left;
        line-height: 1;
    }

    .contents2 {
        /*overflow-y:auto;*/
        padding: 0;
    }

    .contents2>.inner-box {
        max-width: 100%;
        min-width: 1033px;
        padding: 0px 25px 33px 25px;
    }
    .contents2 div.gridbox_material.gridbox .xhdr {
        background: #f3f5f9;
        border-bottom: none;
        max-height: 100%;
        margin-top: -1px;
    }

    .contents2 .grid-tbl-box.type03 div.gridbox_material.gridbox .xhdr {
        height: 112px!important;
    }
    .contents2 div.gridbox_material.gridbox table.hdr td div.hdrcell {
        font-size: 14px;
        line-height: 24px;
        padding: 5.5px 0px;
        text-align: center;
        font-family: NotoM;
        color: #222;
    }
    .right .white-box .data-box{
        height: 213px;
        //overflow: hidden;
        //overflow-x: hidden;
        //overflow-y: auto;
    }

    .quick-menu-v ul {
        display: flex;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .quick-menu-v li {
        list-style: none;
    }

    .quick-menu-v li .rl {
        width: 80px;
        height: 80px;
        background-color: #fff;
        text-align: center;
        //line-height: 80px;
        //font-size: 35px;
        //margin: 0 10px;
        display: block;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        border: 3px solid #fff;
        z-index: 1;
    }

    .quick-menu-v li .rl img {
        display: inline;
        width: auto;
        height: auto;
    }

    .quick-menu-v li .rl .icon {
        position: relative;
        //width: max-content;
        //height: max-content;
        //display: inline-flex;
        color: #262626;
        transition: .5s;
        z-index: 3;
    }

    .quick-menu-v li .rl .ico_main01{top: 60px;}
    .quick-menu-v li .rl .ico_main02{top: 56px;}
    .quick-menu-v li .rl .ico_main03{top: 56px;}
    .quick-menu-v li .rl .ico_main04{top: 50px;}
    .quick-menu-v li .rl .ico_main05{top: 53px;}
    .quick-menu-v li .rl .ico_main06{top: 50px;}
    .quick-menu-v li .rl .ico_main06_01{top: 56px;}
    .quick-menu-v li .rl .ico_main06_02{top: 50px;}
    .quick-menu-v li .rl .ico_main06_03{top: 52px;}
    .quick-menu-v li .rl .ico_main06_04{top: 52px;}
    .quick-menu-v li .rl .ico_main06_05{top: 52px;}
    .quick-menu-v li .rl .ico_main06_06{top: 52px;}
    .quick-menu-v li .rl .ico_main06_07{top: 52px;}

    .quick-menu-v li .rl span {
        position: absolute;
        top : 144px;
        left : 0px;
        right: 0px;
        z-index: 5;
    }

    .quick-menu-v li .rl:hover .icon {
        color: #fff;
        transform: rotateY(360deg);
    }

    .quick-menu-v li .rl:before {
        content: "";
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 100%;
        background: #f00;
        transition: .5s;
        z-index: 2;
    }

    .quick-menu-v li .rl:hover:before {
        top: 0;
    }

    .quick-menu-v li:nth-child(1) .rl:before{background: #5b9fff;}
    .quick-menu-v li:nth-child(2) .rl:before{background: #00a9ff;}
    .quick-menu-v li:nth-child(3) .rl:before{background: #7dff62;}
    .quick-menu-v li:nth-child(4) .rl:before{background: #ff5642;}
    .quick-menu-v li:nth-child(5) .rl:before{background: #ffe35a;}
    .quick-menu-v li:nth-child(6) .rl:before{background: #ff9100;}

    .quick-menu-v:after{clear:both; content:''; display:block;}
    .quick-menu-v li{display:inline-block; float:left; width:211px; border:1px solid #fff; background:#fff; margin-left:20px; border-radius:6px;}

    .quick-menu-v li .rl{width:100%; height:210px; padding:0px 0 0px 0; color:#222; font-size:17px; font-family:'NotoM';}



    .quick-menu-v li:nth-child(1),
    .quick-menu-v li:nth-child(3),
    .quick-menu-v li:nth-child(5){margin-left:10px;}
    .quick-menu-v li:nth-child(3),
    .quick-menu-v li:nth-child(4),
    .quick-menu-v li:nth-child(5),
    .quick-menu-v li:nth-child(6){margin-top:16px;}
    .left .status{width: 440px; margin-left:10px;}
    .wrap.type-main .contents2 .inner .left {width: 455px;}
    .quick-menu-v {width: 455px;}
    .wrap.type-main .contents2 .inner{width:1115px; margin:0 auto;}
    .main-visit {height: 212px; width: 630px; overflow: hidden;}
    .main-visit .data-box{margin-top: 10px;}
    .main-visit .data-box .card-box{width:217px; display: none;}
    .main-visit .data-box .vue-scroll{float: none;}

    //.btn-more {display: none}
    .blue-box li{width:168px; padding:28px 19px;}
    .blue-box li:nth-child(1){margin-left:10px;}
    .blue-box li span.txt-eng{display: none;}
    .blue-box li span.txt-kor{font-size:15px;}
    .blue-box li span.count{font-size:18px;}
    .blue-box li span.count > span{font-size:24px;}
    .white-box.status{display:none;}
    .white-box.status_right{display:block;}
    .wrap.type-main .contents2{padding:100px 0 100px 0;}
    .main-visit .data-box .line-list.using-list{width:533px;}
    .main-visit .data-box .line-list.using-list li span.visitor-comp,
    .main-visit .data-box .line-list.using-list li span.visitor-name,
    .main-visit .data-box .line-list.using-list li span.time{font-size:12px;}
    .main-visit .data-box .line-list.week-list{width:533px;}
    .main-visit .data-box .line-list.week-list li span.visitor-comp,
    .main-visit .data-box .line-list.week-list li span.visitor-name,
    .main-visit .data-box .line-list.week-list li span.visit-emp-name,
    .main-visit .data-box .line-list.week-list li span.date{font-size:12px;}
    .main-visit .data-box .line-list.week-list li span.date{width: 190px; padding-right: 0px;}
    .main-visit .data-box .line-list.week-list li span.visit-emp-name{width:75px;}
    .white-box .data-box .line-list li{padding:4px 6px;}
    .right .white-box .data-box{height: 138px; }

    @media (min-width:1401px) {
        .quick-menu-v li:nth-child(1),
        .quick-menu-v li:nth-child(4){margin-left:0;}
        .quick-menu-v li:nth-child(2),
        .quick-menu-v li:nth-child(3),
        .quick-menu-v li:nth-child(5),
        .quick-menu-v li:nth-child(6){margin-left:20px;}
        .quick-menu-v li:nth-child(4),
        .quick-menu-v li:nth-child(5),
        .quick-menu-v li:nth-child(6){margin-top:16px;}
        .quick-menu-v li:nth-child(3){margin-top:0px;}
        .left .status{width: 670px; margin-left:0px;}
        .wrap.type-main .contents2 .inner .left{width: 675px;}
        .quick-menu-v {width: 675px;}
        .wrap.type-main .contents2 .inner{width:1370px; margin:0 auto;}
        .main-visit {height: 354px; width: 675px;}
        .main-visit .data-box{margin-top: 15px;}
        .card-box,
        .main-visit .data-box .card-box{display: block;}
        .main-visit .data-box .vue-scroll{float: left;}
        //.btn-more {display: block}
        .blue-box li{width:213px; padding:28px 24px;}
        .blue-box li:nth-child(1){margin-left:0px;}
        .blue-box li span.txt-eng{display:inline-block;}
        .blue-box li span.txt-kor{font-size:17px;}
        .blue-box li span.count{font-size:28px;}
        .blue-box li span.count > span{font-size:32px;}
        .white-box.status{height:263px; display:block;}
        .white-box.status_right{display:none;}
        .wrap.type-main .contents2{padding:120px 0 88px 0;}
        .main-visit .data-box .line-list.using-list{width:363px;}
        .main-visit .data-box .line-list.using-list li span.visitor-comp,
        .main-visit .data-box .line-list.using-list li span.visitor-name,
        .main-visit .data-box .line-list.using-list li span.time{font-size:14px;}
        .main-visit .data-box .line-list.week-list{width:593px;}
        .main-visit .data-box .line-list.week-list li span.visitor-comp,
        .main-visit .data-box .line-list.week-list li span.visitor-name,
        .main-visit .data-box .line-list.week-list li span.visit-emp-name,
        .main-visit .data-box .line-list.week-list li span.date{font-size:14px;}
        .main-visit .data-box .line-list.week-list li span.date{width: 220px; padding-right: 20px;}
        .main-visit .data-box .line-list.week-list li span.visit-emp-name{width:95px;}
        .white-box .data-box .line-list li{padding:8px 12px;}
        .right .white-box .data-box{height: 258px;}
    }
</style>
